<template>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <div class="trip-login-wrap">
          <h3>{{ t('requestPasswordResetTitle') }}</h3>

          <div class="trip-border-content">
            <p>{{ t('resetPasswordEmailPlaceholder') }}</p>
          </div>

          <form @submit.prevent="handleRequestReset">
            <div class="trip-login-field">
              <b-form-input
                dir="ltr"
                v-model="email"
                autocapitalize="none"
                id="email"
                :placeholder="t('emailPlaceholder')"
                class="log_in_medium text-right"
                required>
              </b-form-input>
            </div>
            
            <button 
              id="trip-login-btn"
              type="submit"
              :disabled="isLoading">
              <b-spinner small v-if="isLoading"></b-spinner>
              <span v-else>{{ t('requestPasswordResetSendLink') }}</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { translationMixin } from '@/mixins/translationMixin';

export default {
  name: 'RequestPasswordReset',
  mixins: [translationMixin],
  data() {
    return {
      email: '',
      isLoading: false
    };
  },
  methods: {
    ...mapActions(['requestPasswordReset']),
    
    async handleRequestReset() {
      if (!this.validateEmail(this.email)) {
        return;
      }
      
      this.isLoading = true;
      const success = await this.requestPasswordReset(this.email.trim());
      this.isLoading = false;

      if (success) {
        // Clear form
        this.email = '';
      }
    },
    
    validateEmail(email) {
      const trimmedEmail = email.trim();
      
      if (trimmedEmail.includes(' ')) {
        this.$store.dispatch('showModalWithParameters', {
          errorNumber: 'invalid_email_spaces',
          type: 'textConverter'
        });
        return false;
      }
      
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(trimmedEmail)) {
        this.$store.dispatch('showModalWithParameters', {
          errorNumber: 'invalid_email_format',
          type: 'textConverter'
        });
        return false;
      }
      
      return true;
    }
  }
};
</script>

<style scoped>
.modal-dialog {
  max-width: 310px;
  margin: 1.75rem auto !important;
  margin-top: 10% !important;
}

.modal-content {
  background: #FFFFFF;
  box-shadow: 4px 4px 4px rgb(0 0 0 / 10%);
  border-radius: 25px;
  border: none;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 45px 55px;
  border: none;
}

.trip-login-wrap {
  text-align: center;
}

.trip-login-wrap h3 {
  font-weight: 800;
  font-size: 18px;
  line-height: 21px;
  color: #2E2E3A;
  margin-bottom: 15px;
  text-align: center;
}

.trip-border-content {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 12px;
  position: relative;
}

.trip-border-content p {
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #2E2E3A;
  text-align: center;
  position: relative;
  z-index: 1;
  display: inline-block;
  background-color: #fff;
  padding: 0 10px;
}

.trip-border-content::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 1px;
  background-color: #2E2E3A;
  z-index: 0;
}

.trip-login-field {
  margin-bottom: 10px;
}

.trip-login-field input {
  height: 30px;
  width: 100%;
  text-align: right;
  border: 1px solid #C1C0C0;
  border-radius: 22px;
  font-size: 12px;
  line-height: 14px;
  padding: 5px 15px !important;
  color: black;
}

button#trip-login-btn {
  width: 100%;
  height: 30px;
  background: #34D0B6;
  border-radius: 22px;
  border: none;
  font-weight: 500;
  font-size: 12px;
  color: white;
  margin-top: 15px;
}

button#trip-login-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}
</style>
 